// Confirming a note delete. SHORT, for the reason TaskDeleteModal states and the
// calendar's MeetingDeleteModal repeats: the shared DeleteConfirmModal makes you type the
// record's name because deleting a retainer or a job destroys billing history, and that
// friction is proportionate to the loss. A note is one leaf row — nothing references it,
// it owns no file, and no calculation reads the table — so the same ceremony asked
// routinely would stop being read.
//
// What it keeps is the part that matters at any size: the note is NAMED at the top, so
// the confirmation cannot be given against the wrong card after a mis-click on the board
// behind it; the delete is red, so it does not look like the cancel beside it; and a
// refused delete (somebody else's note — 403) leaves the dialog open with the error,
// since nothing was destroyed and it can simply be retried.
import { useState } from 'react';
import he from '../../i18n/he';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { ErrorText } from '../../components/Loader';

export default function NoteDeleteModal({ note, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const confirm = async () => {
    setBusy(true);
    setError(null);
    try {
      await onDeleted();
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <Modal title={he.notes.deleteNote} onClose={onClose}>
      <p>{he.notes.deleteConfirm(note.title)}</p>

      {/* The title is already in the question above; the body is what could be lost. */}
      {note.body && <div className="modal-subject note-body">{note.body}</div>}

      <div className="actions">
        <Button
          onClick={confirm}
          disabled={busy}
          variant="danger"
        >
          {busy ? he.common.deleting : he.common.deletePermanently}
        </Button>
        <Button variant="subtle" onClick={onClose} disabled={busy}>{he.common.cancel}</Button>
      </div>

      {error && <ErrorText error={error} />}
    </Modal>
  );
}
